<template>
  <DefaultLayout>
    <HomePageHeroBanner />
    <!-- <CarrierSlider /> -->
    <Products />
    <StatesWeServe />
    <ConnectWithUs />
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import HomePageHeroBanner from '@/components/marketing/HomePageHeroBanner.vue';
import Products from '@/components/products/Products.vue';
import StatesWeServe from '../components/statesWeServe.vue';
import ConnectWithUs from '../components/ConnectWithUs.vue';

export default {
  name: 'HomePage',
  components: {
    DefaultLayout,
    HomePageHeroBanner,
    Products,
    StatesWeServe,
    ConnectWithUs,
  }
};
</script>

<style>
/* Your HomePage styles here */
</style> 